module.exports = __webpack_public_path__ + "static/media/galleryGT (12).2259e79f.jpg";